// Exports
export default {
	"spaceBottom": "spaceBottom_Ofn-5",
	"spaceBottomV2": "spaceBottomV2_8Rdgy"
};
